import React from "react";
import * as ROUTES from "../../constants/routes";
import Layout from "../Landing/Layout";
import structure from "../Landing/assets/structure.jpg";

const PartnershipModel = () => {
  const franchiseCtaUrl = `https://www.douglasmccartney.com${ROUTES.FRANCHISE_REGISTRATION_DASHBOARD}`;

  return (
    <Layout>
      <section className="page-hero partnership-hero">
        <div className="section-container animate-fade-in-up">
          <div className="grid-12">
            <div className="lg:col-span-12">
              <h1 className="heading-display mb-8">A Structured Partnership Model</h1>

              <div className="mb-12 image-frame hero-image-frame">
                <img
                  src={structure}
                  alt="Structured Architecture"
                  className="w-full h-auto max-h-[500px] object-cover"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                  sizes="100vw"
                />
              </div>

              <div className="text-measure mx-auto space-y-6">
                <p className="body-text text-muted-foreground">
                  Douglas & McCartney operates through a selective partnership model designed for professionals who value discipline, credibility, and long-term alignment. The platform is mandate-led and process-driven, enabling partners to participate across distribution, advisory, and multi-division opportunities - instead of operating as independent transactional brokers.
                </p>
                <p className="body-text text-muted-foreground">
                  The model is built for scalable, sustainable income - supported by systems, governance, and institutional mentorship rather than ad hoc deal flow.
                </p>
                <div className="pt-6 flex justify-center">
                  <a href={franchiseCtaUrl} className="btn-primary inline-block">
                    Become A Frachisee Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-shell section-band section-divider">
        <div className="section-container">
          <div className="grid-12 gap-8">
            <div className="lg:col-span-4 lg:col-start-3 content-card shadow-card">
              <h2 className="heading-subsection heading-mid heading-soft-bold mb-6 text-muted-foreground partnership-points-title">This model is suited for individuals who:</h2>
              <ul className="space-y-3 list-disc pl-5 marker:text-accent text-muted-foreground partnership-points">
                <li className="body-text partnership-point-item">Value systems and accountability</li>
                <li className="body-text partnership-point-item">Seek brand credibility and platform support</li>
                <li className="body-text partnership-point-item">Think long-term</li>
                <li className="body-text partnership-point-item">Are willing to operate within defined frameworks</li>
              </ul>
            </div>
            <div className="lg:col-span-4 content-card shadow-card">
              <h2 className="heading-subsection heading-mid heading-soft-bold mb-6 text-muted-foreground partnership-points-title">It is not designed for:</h2>
              <ul className="space-y-3 list-disc pl-5 marker:text-accent text-muted-foreground partnership-points">
                <li className="body-text partnership-point-item">Short-term income seekers</li>
                <li className="body-text partnership-point-item">Informal or unstructured operations</li>
                <li className="body-text partnership-point-item">Individuals unwilling to follow professional systems</li>
              </ul>
            </div>
          </div>
          <p className="body-text text-center text-measure mx-auto mt-12 italic">
            The focus remains on sustainable professional growth
          </p>
        </div>
      </section>

      <section className="section-shell section-surface section-divider">
        <div className="section-container">
          <div className="grid-12">
            <div className="lg:col-span-8 lg:col-start-3">
              <div className="section-header">
                <h2 className="heading-section mb-4">Practitioner Insights - Field Perspectives That Shape Our Approach</h2>

                <p className="body-text text-muted-foreground text-measure">
                  Real estate is a profession built on judgment, discipline, and consistency - not just intuition or opportunity. The difference between activity and progress often lies in how professionals think about their work.
                </p>
              </div>

              <p className="body-text text-muted-foreground mb-8">
                From years of field experience, partner engagements, and mandate execution, a few principles repeatedly prove true:
              </p>

              <div className="space-y-8">
                <div className="feature-card">
                  <h3 className="heading-subsection heading-mid mb-3">Systems outperform individual effort over time</h3>
                  <p className="body-text text-muted-foreground">
                    Professionals who rely only on relationships or instinct eventually plateau. Structured processes, governed pipelines, and measurable execution create predictability - and predictability creates scale.
                  </p>
                </div>

                <div className="feature-card">
                  <h3 className="heading-subsection heading-mid mb-3">Distribution without alignment leads to leakage</h3>
                  <p className="body-text text-muted-foreground">
                    Channel activity, if not mandate-led and centrally governed, fragments outcomes. Structured distribution, accountability, and data-driven absorption protect value across stakeholders.
                  </p>
                </div>

                <div className="feature-card">
                  <h3 className="heading-subsection heading-mid mb-3">Brand credibility compounds when backed by discipline</h3>
                  <p className="body-text text-muted-foreground">
                    Reputation is not built on visibility alone - it is built on reliability. Markets reward professionals who honor process, timelines, and alignment across transactions.
                  </p>
                </div>

                <div className="feature-card">
                  <h3 className="heading-subsection heading-mid mb-3">Skill without environment has a ceiling</h3>
                  <p className="body-text text-muted-foreground">
                    Many capable brokers stagnate not because of competence, but because they operate in informal systems. The right platform, governance, and mentorship create lift that individuals cannot create alone.
                  </p>
                </div>

                <div className="feature-card">
                  <h3 className="heading-subsection heading-mid mb-3">Long-term success requires moving from transactions to practice</h3>
                  <p className="body-text text-muted-foreground">
                    The industry rewards those who treat real estate as a profession - with learning, structure, and continuous improvement - rather than a short-cycle income opportunity.
                  </p>
                </div>
              </div>

              <p className="body-text text-muted-foreground mt-8 italic">
                These perspectives are not theories - they are lessons observed across years of mandates, partnerships, and market cycles. They shape how Douglas & McCartney designs its operating model, and the type of professionals this platform is built for.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PartnershipModel;
